/**
 * SDK Version injected at build time from package.json
 */

declare const __SDK_VERSION__: string

export const sdkVersion = __SDK_VERSION__
